import React from 'react';
import {colorMapping} from './colors';
import {MdArrowForward} from "react-icons/md";

const TimelineItemWithArrow = ({event, onClick}) => {
  const date = new Date(event.date);

  const formattedDate = date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  return (
    <div className="relative flex items-center pl-4 p-4 mx-2 border-b border-gray-300 dark:border-stone-700"
         onClick={() => onClick(event)}>
      <div className={`absolute left-0 -ml-2 w-4 h-4 rounded-full ${colorMapping[event.type] || 'bg-stone-300'}`}></div>
      <div className="pl-6 flex-1 no-cursor">
        <p className="text-sm text-gray-500">{formattedDate}</p>
        <p className="font-semibold text-gray-600 dark:text-gray-300">{event.name} - {event.description}</p>
      </div>
      <MdArrowForward className="text-gray-600 dark:text-gray-300 ml-2 cursor-pointer"/>
    </div>
  );
};

export default TimelineItemWithArrow;
